<template>
    <div class="task-edit">
      <div class="task filters">
        <el-form :inline="true" :model="taskForm" ref="taskForm" :rules="rules">
          <el-form-item prop="course_id" label="班级">
              <el-select
              size="small"
                v-model="course_id"
                filterable
                remote
                reserve-keyword
                loading-text="加载中..."
                no-match-text="无匹配数据"
                no-data-text="无数据"
                placeholder="选择一个班级"
                disabled
                :remote-method="searchCourse"
                :loading="course_loading">
                <el-option
                  v-for="item in courseList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="lesson_id"  label="授课内容">
            <el-select
            size="small"
              v-model="taskForm.lesson_id"
              filterable
              remote
              reserve-keyword
              loading-text="加载中..."
              no-match-text="无匹配数据"
              no-data-text="无数据"
              placeholder="选择授课内容"
              :remote-method="searchLesson"
              :loading="lesson_loading">
              <el-option
                v-for="item in lessonList"
                :key="item.id"
                :label="item.subject"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="name" label="作业">
            <el-input size="small" v-model="taskForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="submitForm">只保存</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" size="small" @click="PublishForm">保存并发布</el-button>
          </el-form-item>
      </el-form>
      </div>
      <div class="topics">
        <el-table v-loading="loading" empty-text="无数据" :data="topicsList" stripe style="width: 100%">
          <el-table-column label="缩略图" width="170">
            <template slot-scope="scope">
              <div class="thumb" v-if="scope.row.topic_type_id == 4">
                <img :src="scope.row.article_images[0] && scope.row.article_images[0].file.url" alt="">
              </div>
              <div class="thumb" v-else>
                <img :src="scope.row.video_images[0] && scope.row.video_images[0].file.url" alt="">
              </div>
            </template>
          </el-table-column>
          <el-table-column label="内容">
            <template slot-scope="scope">
              {{scope.row.topic_type_id == 4 ? (scope.row.article_references[0] && scope.row.article_references[0].title):(scope.row.transcripts[0] && scope.row.transcripts[0].script)}}
            </template>
          </el-table-column>
          <el-table-column prop="topic_type_name" label="类型"></el-table-column>
          <el-table-column prop="" label="操作" align="left">
              <template slot-scope="scope">
                  <el-button type="warning" size="mini" plain @click="edit(scope.row)" icon="el-icon-edit"></el-button>
                  <el-button type="danger" size="mini" plain @click="remove(scope.row)" icon="el-icon-delete"></el-button>
              </template>
          </el-table-column>
      </el-table>
      </div>
      <div class="editor">
        <el-button type="success" size="mini" @click="showEditor = true;isNew = true" v-if="!showEditor">上传新作业</el-button>
        <topic-editor ref="topic-editor" style="margin:10px 0" v-if="showEditor" :is-new="isNew" :taskid="taskid" :data="topic_data" @success="onSuccess"></topic-editor>
      </div>
    </div>
</template>
<script>
import TopicEditor from '../../components/TopicEditor'
export default {
  name: 'task-form',
  components: { TopicEditor },
  data () {
    let task = this.$store.state.tmp_task
    return {
      isNew: false,
      showEditor: false,
      topic_data: {},
      task: task,
      course_id: task.course_id,
      taskForm: {
        id: task.id,
        lesson_id: task.lesson_id,
        name: task.name
      },
      rules: {
        lesson_id: [{ required: true, message: '课程不能为空' }],
        name: [{ required: true, message: '名称不能为空' }]
      },
      taskid: this.$route.params.taskid || '',

      lesson_loading: false,
      course_loading: false,
      loading: false,
      lessonList: [],
      courseList: [],
      topicsList: []
    }
  },
  created () {
    this.searchCourse()
    this.searchLesson()
    this.getTopics()
  },
  methods: {
    PublishForm (e) {
      this.submitForm(e, 'push')
    },
    onSuccess () {
      this.isNew = false
      this.showEditor = false
      this.getTopics()
    },
    edit (target) {
      // this.isNew = true
      this.showEditor = true
      this.topic_data = target
    },
    submitForm (e, push) {
      this.$refs['taskForm'].validate(valid => {
        if (valid) {
          if (this.showEditor) {
            this.$refs['topic-editor'].done().then(() => {
              this.$api.tasks
                .save(this.taskForm.id, this.taskForm)
                .then(data => {
                  this.$success('作业保存成功')
                  // 保存并发布
                  if (push) {
                    this.$router.push({ path: '/homework/publish',
                      query: {
                        id: this.task.course_id,
                        lesson_id: this.task.lesson_id,
                        task_id: this.task.id
                      } })
                  }
                })
                .catch(err => this.$error(err))
            }).catch(err => this.$error(err))
            return
          }
          this.$api.tasks
            .save(this.taskForm.id, this.taskForm)
            .then(data => {
              this.$success('作业保存成功')
              // 保存并发布
              if (push) {
                if (!this.topicsList.length) {
                  this.$warning('请添加作业')
                  return
                }
                this.$router.push({ path: '/homework/publish',
                  query: {
                    id: this.task.course_id,
                    lesson_id: this.task.lesson_id,
                    task_id: this.task.id
                  } })
              }
            })
            .catch(err => this.$error(err))
        }
      })
    },
    remove (target) {
      this.$confirm(`你确认删除该作业?`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.$api.tasks.topics_delete(this.taskid, target.id).then(data => {
            this.$success('该作业被删除')
            this.getTopics()
          }).catch(err => this.$error(err))
        })
        .catch(() => {})
    },
    getTopics () {
      this.loading = true
      this.$api.tasks.topics(this.taskid).then(data => {
        this.topicsList = data
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    searchCourse (name) {
      this.course_loading = true
      this.$api.courses
        .list({ fields: ['id', 'name'], page: 1, per_page: 100, name })
        .then(data => {
          this.courseList = data.data
          this.course_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.course_loading = false
        })
    },
    searchLesson (subject) {
      this.lesson_loading = true
      this.$api.courses
        .lessons({
          id: this.course_id,
          fields: ['id', 'subject'],
          page: 1,
          per_page: 100,
          subject
        })
        .then(data => {
          this.lessonList = data
          this.lesson_loading = false
        })
        .catch(err => {
          this.$error(err)
          this.lesson_loading = false
        })
    }
  },
  destroyed () {
    this.$store.commit('tmp_topic', this.topic)
  }
}
</script>
<style lang="scss">
.editor{
  margin: 20px 0;
}
</style>
